import React from 'react';
import { useForm } from 'react-hook-form';
import apiClient from '../data/apiClient'; // Assuming apiClient is configured correctly
import { TextInput, Button, Textarea, Alert } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';

const DonationForm = () => {
  const { register, handleSubmit, formState: { errors, isSubmitting }, reset } = useForm();
  const [submitError, setSubmitError] = React.useState(null);

  const onSubmit = async (data) => {
    setSubmitError(null); // Clear previous errors
    try {
      // Mock API call - replace with actual donation endpoint
      await apiClient.post('/api/donations', data); 
      reset(); // Clear form on successful submission
      alert('Thank you for your donation!');
    } catch (error) {
      console.error('Donation submission error:', error);
      setSubmitError('Failed to submit donation. Please try again later.');
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {submitError && (
        <Alert
          icon={<IconAlertCircle size={16} />}
          title="Error"
          color="red"
          mb="md"
        >
          {submitError}
        </Alert>
      )}

      <TextInput
        label="Full Name"
        placeholder="Your Name"
        {...register('fullName', { required: 'Full name is required' })}
        error={errors.fullName?.message}
        mb="sm"
        disabled={isSubmitting}
      />
      <Textarea
        label="Donation Amount"
        placeholder="Enter amount (e.g., 100)"
        {...register('donationAmount', { 
          required: 'Donation amount is required',
          pattern: {
            value: /^\d+$/,
            message: 'Please enter a valid number for donation amount',
          },
        })}
        error={errors.donationAmount?.message}
        mb="sm"
        disabled={isSubmitting}
      />
      <Textarea
        label="Your Message"
        placeholder="Your message (optional)"
        {...register('message')}
        mb="md"
        disabled={isSubmitting}
      />
      <Button type="submit" loading={isSubmitting}>
        Donate
      </Button>
    </form>
  );
};

export default DonationForm;
